import { render, staticRenderFns } from "./value.vue?vue&type=template&id=03b2fda4&"
import script from "./value.vue?vue&type=script&lang=ts&"
export * from "./value.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03b2fda4')) {
      api.createRecord('03b2fda4', component.options)
    } else {
      api.reload('03b2fda4', component.options)
    }
    module.hot.accept("./value.vue?vue&type=template&id=03b2fda4&", function () {
      api.rerender('03b2fda4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "core/vue/base/value.vue"
export default component.exports